import isString from 'lodash/isString';

import { REGEX_DATA_URL } from 'constants/regex';

const isDataUrl = (str = '') => isString(str) && str.match(REGEX_DATA_URL);

export default isDataUrl;
